import React from 'react';
import './App.css';

import Header from './components/Header';
import Overview from './components/Overview';
import Skills from './components/Skills';
import AboutMe from './components/AboutMe';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Education from './components/Education';
import Footer from './components/Footer';

function App() {
    return (
        <div className="App">
            <Header />
            <Overview />
            <AboutMe />
            <div className="bg-dark-gray">
            <Skills />
            </div>
            <Projects />
            <Experience />
            <Education />
            <Footer />
        </div>
    );
}

export default App;
